import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import isEmpty from 'lodash/isEmpty';
import omitBy from 'lodash/omitBy';
import { extractAWCDataFromEvent, fireOperationalAnalytics } from '@atlassian/analytics-bridge';
import { captureException } from './sentry';

// it's a workaround since React doesn't provide native types for this

// At the time of writing, @atlassiansox/analytics-web-client did not publish types,
// if it now does that you should use those types instead (check https://experimentation-platform.atlassian.net/browse/MEP-1586)

var analyticsClient;
export var initialiseErrorAnalyticsClient = function initialiseErrorAnalyticsClient(client) {
  analyticsClient = client;
};

//This method exists only for testing, there shouldn't be any reason for this to be used outside of tests
export var clearErrorAnalyticsClient = function clearErrorAnalyticsClient() {
  analyticsClient = undefined;
};
var fireErrorAnalytics = function fireErrorAnalytics(_ref) {
  var event = _ref.event,
    error = _ref.error,
    errorInfo = _ref.errorInfo,
    meta = _ref.meta,
    attributes = _ref.attributes;
  var id = meta.id,
    packageName = meta.packageName,
    teamName = meta.teamName;
  if (__SERVER__) {
    if (error) {
      throw error;
    } else {
      var payload = event && extractAWCDataFromEvent(event).payload;
      throw new Error(JSON.stringify({
        event: payload,
        errorInfo: errorInfo,
        meta: meta,
        attributes: attributes
      }));
    }
  }
  var fullAnalyticsId = "".concat(packageName, ".").concat(id);
  if (error) {
    var details = omitBy(_objectSpread(_objectSpread({}, attributes), {}, {
      packageName: packageName,
      teamName: teamName,
      errorInfo: errorInfo
    }), isEmpty);
    if (event && event.context) {
      var fullEvent = extractAWCDataFromEvent(event);
      captureException(fullAnalyticsId, error, _objectSpread(_objectSpread({}, details), fullEvent.payload));
    } else {
      captureException(fullAnalyticsId, error, details);
    }
  }
  if (event && event.handlers && event.handlers.length > 0) {
    var attrs = attributes || {};
    fireOperationalAnalytics(event, "".concat(fullAnalyticsId, " failed"), attrs);
  } else {
    //Allow this to pass in a promise so that we can avoid blocking render for firing these events.
    if (analyticsClient && analyticsClient.sendOperationalEvent) {
      var gasV3Event = {
        action: 'failed',
        actionSubject: fullAnalyticsId,
        source: 'unknownErrorSource',
        attributes: attributes
      };
      analyticsClient.sendOperationalEvent(gasV3Event);
    } else {
      var analyticsClientUninitialisedError = new Error("Analytics client hasn't been initialised, unable to fire error operational event");
      captureException(fullAnalyticsId, analyticsClientUninitialisedError);
    }
  }
};
export var trackFetchErrors = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref2) {
    var error, id, packageName, statusCode, statusCodeGroup;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          error = _ref2.error, id = _ref2.id, packageName = _ref2.packageName;
          if (!error.statusCode) {
            _context.next = 8;
            break;
          }
          statusCode = error.statusCode;
          if (statusCode >= 300 && statusCode < 400) {
            statusCodeGroup = '3xx';
          } else if (statusCode >= 400 && statusCode < 500) {
            statusCodeGroup = '4xx';
          } else if (statusCode >= 500 && statusCode < 600) {
            statusCodeGroup = '5xx';
          } else {
            statusCodeGroup = 'unknown';
          }
          _context.next = 6;
          return fireErrorAnalytics({
            meta: {
              id: id,
              packageName: packageName
            },
            attributes: {
              statusCodeGroup: statusCodeGroup
            }
          });
        case 6:
          _context.next = 10;
          break;
        case 8:
          _context.next = 10;
          return fireErrorAnalytics({
            error: error,
            meta: {
              id: id,
              packageName: packageName
            }
          });
        case 10:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function trackFetchErrors(_x) {
    return _ref3.apply(this, arguments);
  };
}();
export default fireErrorAnalytics;